import styled from 'styled-components';

import { colors, sizes } from '@crm-framework/theme';

export const ImportsWrapper = styled.div`
  flex: 1;
  display: flex;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
`;

export const Header = styled.h3`
  margin: 0;
  font-weight: 600;
  color: ${colors.HEADING};
`;

export const UploadArea = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  background-color: ${colors.WHITE};
  border: 1px dashed ${colors.B7};
  border-radius: ${sizes.DEFAULT_BORDER_RADIUS};
`;

export const UploadContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 500px;
`;

export const NextSteps = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 15px;
`;

export const NextStepsHeader = styled.div`
  font-size: 16px;
  margin-bottom: 15px;
  color: ${colors.N7};
`;

export const TryAgainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
`;

export const ServerMessage = styled.div`
  font-size: 16px;
  margin: 10px 0;
  color: ${colors.N7};
`;
